<template>
  <div>
    <div class="container-fluid">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-4 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none"> Parceiros </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">Parceiros</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-5 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-parceiro">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Parceiro
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive" style="background-color: #fff">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Telefone</th>
                  <th>Email</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-parceiros
                    v-for="parceiro in state.parceiros"
                    :key="parceiro.id"
                    :parceiro="parceiro"
                    @deletarParceiro="deletarParceiro"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import { onMounted, reactive } from "vue";
import CorpoTabelaParceiros from "../../components/CorpoTabelaParceiros";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaParceiros,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      parceiros: [],
    });
    onMounted(() => {
      fetchParceiros();
    });
    async function fetchParceiros() {
      try {
        const { data } = await services.parceiros.getAll({ token });
        console.log(data);
        state.parceiros = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarParceiro(id) {
      if (confirm("Deseja deletar o parceiro?")) {
        try {
          state.isLoading = true;
          const { data } = await services.parceiros.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar parceiro.");
          } else {
            fetchParceiros();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarParceiro,
    };
  },
};
</script>
  
  <style scoped>
table {
  color: black;
}
.div_btn_usuario {
  text-align: right;
  padding-right: 30px;
}
.div_tabela {
  height: auto;
}
.div_btn_usuario {
  text-align: right;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>